import styled from '@emotion/styled/macro';
import NavigationFocusIndicator from '../../components/Icons/NavigationFocusIndicator/NavigationFocusIndicator';
import rem from '../../utils/rem/rem';
import Button from '../../components/Button/Button';
import { Link } from 'react-router-dom';

export const SkipNav = styled(Button)`
  position: fixed;
  top: -1000px;
  left: -1000px;
  z-index: 11;

  &:focus {
    top: 0;
    left: ${rem(144)};
  }
`;

export const VersionsContainer = styled.div`
color: ${({ theme }) => theme.colors.gray700};
margin-top: auto;
`;

export const NavigationContainer = styled.nav`
  width: ${rem(144)};
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.colors.gray700};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.5);
  position: relative;
  height: 100%;
`;

export const LogoContainer = styled(Link)`
  border: none;
  padding: ${rem(50)} ${rem(18)};
  height: ${rem(39)};
  width: ${rem(98)};
`;

export const FocusTriangle = styled(NavigationFocusIndicator)`
  position: absolute;
  right: 0;
  display: none;
  z-index: 11;
`;
